import buildVersion from "../version.json";

export type Trial = "sienna" | "dfi18231" | "pharma3" | "local" | "unknown";
export type Environment = "dev" | "prod" | "unknown";

interface DeploymentContext {
  trial: Trial;
  environment: Environment;
}

function deploymentFromHostname(hostname: string): DeploymentContext {
  const normalizedHostname = hostname.toLowerCase();

  // Development hostnames must be checked before their production prefixes.
  if (normalizedHostname.includes("vvp-sienna-localizer-dev")) {
    return { trial: "sienna", environment: "dev" };
  }
  if (normalizedHostname.includes("vvp-pharma-localizer")) {
    return { trial: "sienna", environment: "prod" };
  }
  if (normalizedHostname.includes("vvp-dfi18231-localizer-dev")) {
    return { trial: "dfi18231", environment: "dev" };
  }
  if (normalizedHostname.includes("vvp-dfi18231-localizer")) {
    return { trial: "dfi18231", environment: "prod" };
  }
  if (normalizedHostname.includes("vvp-pharma3")) {
    return { trial: "pharma3", environment: "prod" };
  }
  if (normalizedHostname === "localhost" || normalizedHostname === "127.0.0.1") {
    return { trial: "local", environment: "dev" };
  }

  return { trial: "unknown", environment: "unknown" };
}

export const { version, sha, builtAt } = buildVersion;
export const { trial, environment } = deploymentFromHostname(
  window.location.hostname
);

// Hosted builds can't `git describe` (shallow clone, no tags), so version falls
// back to the SHA — collapse the "cbbbee5 (cbbbee5)" duplication when it does.
const versionText = version === sha ? sha : `${version} (${sha})`;

export const versionLabel = `${trial} · ${environment} · ${versionText}`;

let hasLoggedVersion = false;

export function logVersion(): void {
  if (hasLoggedVersion) {
    return;
  }

  const buildStamp = builtAt ? ` · built ${builtAt}` : "";
  console.info(
    `%c VVP Stimulus Placer %c ${trial} · ${environment} %c ${versionText}${buildStamp} `,
    "background:#2b6cb0;color:#fff;padding:2px 6px;border-radius:3px 0 0 3px;font-weight:600",
    "background:#1a202c;color:#fff;padding:2px 6px",
    "background:#edf2f7;color:#2d3748;padding:2px 6px;border-radius:0 3px 3px 0"
  );
  hasLoggedVersion = true;
}
